import Chart from 'chart.js/dist/Chart.bundle.min';

export default {

    TOOLTIPS: {

        hide() {
            const tooltip = document.getElementById('chart-tooltip');
            tooltip.style.pointerEvents = 'none';
            tooltip.style.opacity = '0';
        },

        show(action, segments, element, event) {

            if ( ! action) {
                return;
            }

            if (typeof this[action] === 'function') {
                return this[action](segments, element, event);
            }

        },

        openWindow(link) {
            window.open(link.url);
        },

        redirect(link) {
            window.location = link.url;
        },

        link(segments, element, event) {

            const linkData = this.matchSegmentLink(segments, element._model);

            if (linkData.target === '_blank') {
                this.openWindow(linkData);
                return;
            }

            this.redirect(linkData);

        },

        matchSegmentLink(segments, model) {

            let match = false;

            [].forEach.call(segments, segment => {
                if (segment.name === model.label) {
                    match = segment;
                }
            });

            return match.link ? match.link : false;

        },

        table(segments, element, event) {

            let tooltipNode = document.getElementById('chart-tooltip');

            if ( ! tooltipNode) {

                tooltipNode = document.createElement('div');
                tooltipNode.id = 'chart-tooltip';
                tooltipNode.classList.add('chart-tooltip');
                tooltipNode.innerHTML = '<table></table>';

                document.getElementById('app').appendChild(tooltipNode);

            }

            if (element._model.opacity === '0') {
                tooltipNode.style.opacity = '0';
                return;
            }

            tooltipNode.classList.remove('above', 'below', 'no-transform');

            if (element._model.yAlign) {
                tooltipNode.classList.add(element._model.yAlign);
            } else {
                tooltipNode.classList.add('no-transform');
            }

            const tableData = this.matchSegmentTable(segments, element._model);
            const tableRoot = tooltipNode.querySelector('table');
            tableRoot.innerHTML = this.buildTable(tableData);

            tooltipNode.style.opacity = '1';
            tooltipNode.style.position = 'absolute';
            tooltipNode.style.left = (window.pageXOffset + element._chart.canvas.getBoundingClientRect().left + event.offsetX) + 'px';
            tooltipNode.style.top = (window.pageYOffset + element._chart.canvas.getBoundingClientRect().top + event.offsetY) + 'px';
            tooltipNode.style.pointerEvents = 'all';

            tooltipNode.addEventListener('mousemove', moveEvent => {
                document.body.style.cursor = moveEvent.target.nodeName === 'A' || moveEvent.target.parentNode.nodeName === 'A' ? 'pointer' : 'default';
            });

            document.body.addEventListener('click', this.bodyTooltipListener, true);

        },

        matchSegmentTable(segments, model) {

            let match = false;

            [].forEach.call(segments, segment => {
                if (segment.name === model.label) {
                    match = segment;
                }
            });

            return match.table ? match.table.data : false;

        },

        buildTable(data) {

            let html = '<thead><tr><th>' + data.title.value + '</th></tr></thead>';
            html += '<tbody>';

            [].forEach.call(data.rows, row => {

                html += '<tr>';

                [].forEach.call(row.cells, cell => {

                    if (typeof cell.link === 'object') {

                        html += '<td><a href="' + cell.link.url + '"';

                        if (cell.target) {
                            html += ' target="' + cell.link.target + '"';
                        }

                        html += '>';

                        if (cell.link.media) {
                            html += '<img src="/api/resources/media?fileName=' + cell.link.media.img + '&size=icon" alt="' + cell.link.media.alt + '" class="icon" height="32" width="32">';
                        } else {
                            html += cell.link.value;
                        }

                        html += '</a>';

                    } else if (typeof cell.value === 'string') {
                        html += '<td>' + cell.value + '</td>';
                    }

                });

                html += '</tr>';

            });

            html += '</tbody>';

            return html;

        },

        bodyTooltipListener(event) {

            let tooltipNode = document.getElementById('chart-tooltip');

            if ( ! tooltipNode.contains(event.target)) {
                tooltipNode.style.pointerEvents = 'none';
                tooltipNode.style.opacity = '0';
                document.body.removeEventListener('click', this.bodyTooltipListener);
            }

        }

    },

    WIDGETS: {

        horizontalBar(ctx, values, labels, colours, options) {

            if (values.length !== labels.length || values.length !== colours.length) {
                return;
            }

            const chart = new Chart(ctx, {
                type: 'horizontalBar',
                data: {
                    labels: labels,
                    datasets: [{
                        data: values,
                        backgroundColor: colours
                    }]
                },
                options: options,
            });

            window.charts.push(chart);

            return chart;

        },

        line(ctx, values, labels, colours, options, names) {

            if (values.length !== labels.length || values.length !== colours.length) {
                return;
            }

            const datasets = [];

            for (let i = 0; i < values.length; i++) {
                datasets.push({
                    label: names[i],
                    backgroundColor: colours[i],
                    borderColor: colours[i],
                    data: values[i],
                    fill: false
                });
            }

            const chart = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: labels.flat(),
                    datasets: datasets
                },
                options: options,
            });

            window.charts.push(chart);

            return chart;

        },

        pie(ctx, values, labels, colours, options, isDonut = false) {

            if (values.length !== labels.length || values.length !== colours.length) {
                return;
            }

            const chart = new Chart(ctx, {
                type: isDonut ? 'doughnut' : 'pie',
                data: {
                    labels: labels,
                    datasets: [{
                        data: values,
                        backgroundColor: colours
                    }]
                },
                options: options,
            });

            window.charts.push(chart);

            return chart;

        },

        donut(ctx, values, labels, colours, options) {
            return this.pie(ctx, values, labels, colours, options, true);
        }

    }

};
